import {Injectable} from "@angular/core";
import * as moment from 'moment';
@Injectable()
export class DatetimeService{
  formattedDateTime(datetime){
    return moment.utc(datetime).local().format("MM/DD/YYYY hh:mm a")
  }
  validDate(datetime){
    return datetime && moment(datetime).isValid();
  }
  serverDateTime(datetime){
    return moment(datetime).toString();
  }
  formatDate(date){
    return moment(date).format("MM/DD/YYYY");
  }
  formatUploadDate(date){
    return moment(date).format("YYYY-MM-DD");
  }
  createAgeString(birthDate){
    let dateOfBirthMoment: moment.Moment = moment(birthDate);
    return moment().diff(dateOfBirthMoment, 'years');
  }
}
